export default __webpack_public_path__ + "static/media/fireflamecurved-1.d6153b32.svg";